import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";
import { lodashFunctionsList } from "./lodashFunctions";
import { LodashOption } from "./types";

interface LodashFunctionSelectorProps {
  lodashFn: string;
  addLodashFn: (lodashFn: string) => void;
}

const LodashFunctionSelector: React.FC<LodashFunctionSelectorProps> = ({
  lodashFn,
  addLodashFn,
}) => {
  return (
    <FormGroup>
      <Label for="lodashFn">Fonctions Lodash</Label>
      <Select
        id="lodashFn"
        name="lodashFn"
        options={lodashFunctionsList}
        value={null}
        onChange={(option: any) => {
          if (option) {
            addLodashFn(option.value);
          }
        }}
        placeholder="Ajouter une fonction Lodash..."
        isClearable
        // Utiliser l'ID unique comme clé pour chaque option
        getOptionValue={(option: LodashOption & { id?: string }) => {
          // Vérifier si option est null ou undefined
          if (!option) return "";
          // Utiliser id s'il existe, sinon utiliser value
          return option.id || option.value;
        }}
      />
    </FormGroup>
  );
};

export default LodashFunctionSelector;
